import { getIntegrationName } from "Shared/helpers/getIntegrationName"
import React, { useEffect } from "react"

export const OAuthErrorRoute: React.FC = () => {
  const queryParams = new URLSearchParams(window.location.search)
  const integration = getIntegrationName(queryParams.get("integration"))

  useEffect(() => {
    if (integration) {
      window.opener?.postMessage({ type: "OAUTH_ERROR", integration }, "*")
      window.close()
    }
  }, [integration])

  return null
}
